const END_OF_MODULE_BEHAVIORS = {
    goToNextModule: 0,
    goToProgramme: 1,
};

export const renderConfig = {
    END_OF_MODULE_BEHAVIORS: END_OF_MODULE_BEHAVIORS,
    endOfModuleBehavior: END_OF_MODULE_BEHAVIORS.goToProgramme,
};